import { render } from "./InputEditor.vue?vue&type=template&id=501b4ca2"
import script from "./InputEditor.vue?vue&type=script&lang=js"
export * from "./InputEditor.vue?vue&type=script&lang=js"

import "./InputEditor.vue?vue&type=style&index=0&id=501b4ca2&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__